import type { ReactNode } from "react";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { SortByItemLinks as SortByItemLinksComponent } from "./SortByItemLinks";
import { useSortBy } from "./useSortBy";

export interface SortByDropdownProps {
  button?: ReactNode;
  defaultSort: string;
  exclude?: string[];
  include?: string[];
  onChange: (value: string) => void;
  shouldOpenToLeft?: boolean;
}

export const SortByDropdown = ({
  defaultSort,
  include,
  exclude,
  shouldOpenToLeft = false,
  onChange,
  button,
}: SortByDropdownProps) => {
  const { sort, sortingOptions } = useSortBy({ defaultSort, exclude, include });
  const activeOptionValue = sort ? String(sort) : undefined;

  return (
    <Dropdown
      direction={shouldOpenToLeft ? "bottom-start" : "bottom-end"}
      options={sortingOptions}
      activeOptionValue={activeOptionValue}
      onChange={onChange}
      button={button}
    />
  );
};

export const SortByItemLinks = SortByItemLinksComponent;
